import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FooterNavigation, Header, PaginationHelper, TitleBar, Dialog } from "webapp/components";
import { AppState } from "webapp/enums/AppState";
import { devLog } from "utils/devLog";
import APCOMemberInformationForm from "webapp/components/Partner/APCO/APCOMemberInformationForm";
import PPUConsentScreen from "webapp/components/Partner/CIBC/PPUConsentScreen/PPUConsentScreen";

export default function APCOMemberInformation(props) {
  const { t } = useTranslation();
  const [memberInfo, setMemberInfo] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [showSelectUserModal, setShowSelectUserModal] = useState(false);
  const [showMNFInputError, setShowMNFInputError] = useState(false);
  const [showOOPConsent, setShowOOPConsent] = useState(false);
  const [lookupSucceeded, setLookupSucceeded] = useState(false);

  const [MNFMemberInfoData, setMNFMemberInfoData] = useState({
    firstName: props.currState.MemberLookup?.firstName || props.currState.FirstName || "",
    lastName: props.currState.MemberLookup?.lastName || props.currState.LastName || "",
    phoneNumber: props.currState.MemberLookup?.phoneNumber || props.currState.Number || "",
    last8Vin: props.currState.MemberLookup?.last8Vin || "",
    havingTrouble: false,
  });

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("description.PolicyInformationVerifyHeader")}</strong>
          <br />
        </p>
      </>
    ),
  };

  const proceedWithMNF = () => {
    props.context.setState(
      {
        accountRef: null,
        memberRef: null,
        contactRef: null,
        FirstName: MNFMemberInfoData.firstName.trim(),
        LastName: MNFMemberInfoData.lastName.trim(),
        Number: MNFMemberInfoData.phoneNumber.trim(),
        allowVehicleInfoEdits: true,
        MemberLookup: {
          ...props.currState.MemberLookup,
          ...MNFMemberInfoData,
          firstName: MNFMemberInfoData.firstName.trim(),
          lastName: MNFMemberInfoData.lastName.trim(),
          phoneNumber: MNFMemberInfoData.phoneNumber.trim(),
          last8Vin: MNFMemberInfoData.last8Vin.trim().toUpperCase(),
          acceptOOPConsent: true,
        },
        webAppState: AppState.ConfirmVehicle,
      },
      () => {
        if (typeof props.onUserNext === "function") {
          props.onUserNext();
        }
        props.context.saveWebAppState(props.context);
      },
    );
  };

  const onUserNext = () => {
    const contactRef = selectedContact?.contactRef || memberInfo?.contactRef;
    devLog("onUserNext", memberInfo, selectedContact, contactRef, MNFMemberInfoData);

    if (MNFMemberInfoData.havingTrouble) {
      const isMNFInputInvalid =
        !MNFMemberInfoData.firstName?.trim() ||
        !MNFMemberInfoData.lastName?.trim() ||
        !MNFMemberInfoData.phoneNumber?.trim() ||
        !MNFMemberInfoData.last8Vin?.trim() ||
        MNFMemberInfoData.last8Vin.trim().length !== 8;

      if (isMNFInputInvalid) {
        setShowMNFInputError(true);
        return;
      }

      setShowOOPConsent(true);
      return;
    }

    if (memberInfo && contactRef) {
      props.context.setState(
        {
          accountRef: memberInfo.accountRef,
          contactRef: contactRef,
          Year: memberInfo.year,
          Color: memberInfo.color,
          Model: memberInfo.model,
          Make: memberInfo.make,
          allowVehicleInfoEdits: false,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          if (typeof props.onUserNext === "function") {
            props.onUserNext();
          }
          props.context.saveWebAppState(props.context);
        },
      );
    } else {
      setShowSelectUserModal(true);
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const onContractLookupComplete = (success) => {
    devLog("success", success);
    setLookupSucceeded(!!success);
    // Initial lookup failure resets MNF form; Yes-click passes success=true to keep footer
    if (!success && !MNFMemberInfoData.havingTrouble) {
      setMNFMemberInfoData((prev) => ({ ...prev, havingTrouble: false }));
    }
  };

  const onHavingTroubleChange = (havingTrouble) => {
    setMNFMemberInfoData((prev) => ({ ...prev, havingTrouble: !!havingTrouble }));
  };

  const onUserSelectMember = (memberInfo, selectedContact) => {
    devLog("onUserSelectMember", memberInfo, selectedContact);
    setMemberInfo(memberInfo);
    setSelectedContact(selectedContact);
  };

  const shouldShowFooter = lookupSucceeded || MNFMemberInfoData.havingTrouble;

  return (
    <>
      <div className="CustCollectPage">
        <Header
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          information={t("BWC.PolicyInformation.PolicyInformationHeader1")}
        />
        <TitleBar data={LocateUserObj} />
        <PaginationHelper context={props.context} />
        <APCOMemberInformationForm
          context={props.context}
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          onUserCancel={onUserCancel}
          onLoad={onContractLookupComplete}
          onMemberInfo={onUserSelectMember}
          onHavingTroubleChange={onHavingTroubleChange}
          MNFMemberInfoData={MNFMemberInfoData}
          setMNFMemberInfoData={setMNFMemberInfoData}
        />
      </div>
      {shouldShowFooter ? <FooterNavigation onCancelClick={onUserCancel} onNextClick={onUserNext} /> : <></>}
      {showSelectUserModal && (
        <Dialog
          title={"DriverMissing"}
          message={"ErrorSelectContacts"}
          buttonTitle={"OK"}
          onClose={() => {
            setShowSelectUserModal(false);
          }}
        />
      )}
      {showMNFInputError && (
        <Dialog
          title={"ErrorMNFInput"}
          message={"ErrorMNFInputMsg"}
          buttonTitle={"OK"}
          onClose={() => {
            setShowMNFInputError(false);
          }}
        />
      )}
      {showOOPConsent && (
        <PPUConsentScreen
          context={props.context}
          currState={props.currState}
          partnerCode="APCO"
          onYes={() => {
            setShowOOPConsent(false);
            proceedWithMNF();
          }}
          onNo={() => {
            setShowOOPConsent(false);
          }}
        />
      )}
    </>
  );
}
